export const USERS = "users";
export const ORGANIZATIONS = "organizations";
export const ORDERS = "orders";
export const PRODUCTS = "products";
export const CLIENT_LAST_ORDERS = "client_last_orders";
export const DELIVERY_AREAS = "deliveryAreas";
export const FCM_TOKENS = "fcm_tokens";
